/**
 * 인증 상태 관리 (Zustand)
 *
 * 챗봇 초기화 시 /chatbot/api/init.jsp 호출하여 받은 정보를 저장.
 * 페이지 컨텍스트도 함께 관리 (재발송 시 활용).
 */

import { create } from 'zustand';
import type { AuthStatus, User, PageContext, ChatbotConfig } from '@/types/api';

interface AuthState {
  // 상태
  status: AuthStatus;
  user: User | null;
  context: PageContext | null;
  config: ChatbotConfig | null;
  isInitialized: boolean;

  // 액션
  setAuth: (data: {
    status: AuthStatus;
    user: User | null;
    context: PageContext;
    config: ChatbotConfig;
  }) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'anonymous',
  user: null,
  context: null,
  config: null,
  isInitialized: false,

  setAuth: ({ status, user, context, config }) => {
    set({
      status,
      user,
      context,
      config,
      isInitialized: true,
    });
  },

  reset: () => {
    set({
      status: 'anonymous',
      user: null,
      context: null,
      config: null,
      isInitialized: false,
    });
  },
}));
